import React, { useState, useEffect, useMemo } from "react";
import { DataGrid } from '@genesis/ui-kit';
import classes from "../Preference Groups/preferencegroups.module.scss";
import {
    Grid
  } from '@mui/material';
  import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import {
    DataGridPro,
  useGridApiRef,
  GRID_DETAIL_PANEL_TOGGLE_FIELD
} from "@mui/x-data-grid-pro";
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { AllControlSearchView } from "../RuleAssignments/Search/RuleAssignmentsSearch";
import { Icon,DatePicker } from '@genesis/ui-kit';
import axios from "axios";
import { useSelector } from "react-redux";
import Cookies from "js-cookie";
import { methods } from "underscore";
import { useNavigate, NavLink,useLocation } from "react-router-dom";
import { constants } from "../../../../Shared/Url/Constants";
import { CheckIsUserAdmin, convertDateToMMDDYYYYString } from "../../../../Shared/Utill/Utills";
import AdminControlsDataGrid from '../../AdminControlsDataGrid';
import UnpublishedOutlinedIcon from '@mui/icons-material/UnpublishedOutlined';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import SnackBar from "../../../../Shared/Snackbar/Snackbar";
import DivisionDropDownComp from "../../DivisionDropdown/DivisionDropdownComp";
import { AddPlusIcon } from "../../../../Resources/availabilityicon/IconUtils";
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreHoriz';
import EventLocationsDialog from "../../EventParentControls/EventLocationsList/EventLocationsDialog";
import DeleteEventDialog from "./DeleteEventDialog";
import DuplicateEventDialog from "./DuplicateEventDialog";
import { isString } from '../../../../Shared/Utill/Utills';
import AddEditPreferenceGrouping from '../Preference Groups/AddEditPreferenceGrouping';
import { toUpperCaseString } from '../../../../Shared/Utill/Utills';


const PreferenceGroupsGrid = (props) => {

    // state setup for grid
    /*Note for future devs, if this looks confusing check out the mui data grid pro documention, they have examples that help make sense of this - Clayton A. Seals II (gl coding!)*/
    
    const ITEM_HEIGHT = 48;
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [passedRows, setPassedRows] = React.useState(props.data);
    console.log("hhhhhhhhhh "+ JSON.stringify(passedRows))
    const openOption = Boolean(anchorEl);
    //props.data.map( e=> console.log("trying to break up array of objects" + JSON.stringify(e)))
    const [selectionModel, setSelectionModel] = React.useState([]);
    
    const [showPG,setShowPG] = React.useState(false) 


    const apiRef = useGridApiRef()
    

    useEffect(() => {
      // might need a callback function that takes a updated flag for after an update is made, so the grid refreshes locations
      // from inactive to active
      //console.log(rows)
      console.log(selectionModel)
  }, [passedRows,selectionModel]);
    const onRowClick = React.useCallback(
        params => {
        apiRef.current.toggleDetailPanel(params.id)
        },
        [apiRef]
    )

    
    

    const getDetailPanelHeight = React.useCallback(() => 'auto', []);

    //console.log("FIX MEEEE "+props.data)
    const rows = passedRows
    
    // console.log("temp",rows.length)



    const columns = [
    
    { field: 'pwhNbr', headerName: 'PWH Grp No.', width: 150 },
    { field: 'pwhConfigured', headerName: 'Preferences Configured', width: 749, renderCell: (params) => {
      if((params.row.pwhConfigured)) {
        return (
        <div
          className="d-flex justify-content-between align-items-center"
          
        >
        <CheckCircleOutlinedIcon style={{color:"#008757"}} /> <span style={{marginLeft:"5px" }}>Active</span>
        </div>);
      } else {
      return (
        <div
          className="d-flex justify-content-between align-items-center"
          style={{ cursor: "pointer" }}
        >
        <UnpublishedOutlinedIcon /> <span style={{marginLeft:"5px" }}> Inactive </span>
        </div>
      
      );
      }
    }},
    ];

    const getDetailPanelContent =
     React.useCallback(
      ({ row }) => <DetailPanelContent currentRow={row}/>,
      []
    )

    const DetailPanelContent = (currentRow) => {
    
      if (rows.length > 0 && (apiRef && rows)) {
        //console.log("WOOOOT " + props.row)
        console.log("Checking for second selection" +selectionModel.length)
        console.log("THE DATA IS HERE" + JSON.stringify(rows))
        return (
            <AddEditPreferenceGrouping data = {rows} apiRef = {apiRef} flag={"E"} currentRow = {currentRow} ></AddEditPreferenceGrouping>
          )
      } else {
        console.log(rows.length)
      }
     
  }

    
    return (
        <div style={{ height: '100%', width: '100%' }}>
        <DataGridPro
         rows={rows} 
         columns={columns}
         apiRef={apiRef}
         onRowClick={onRowClick}
         rowThreshold={0}
         onSelectionModelChange={(selection) => {
          if (selection.length === 1) {
            console.log("length is whatt?")
            const selectionSet = new Set(selectionModel);
            const result = selection.filter((s) => !selectionSet.has(s));

            setSelectionModel(result);
          } else {
            setSelectionModel(selection);
          }
        }}
         getDetailPanelHeight={getDetailPanelHeight}
         getDetailPanelContent={getDetailPanelContent}
          />
         
        </div>
    );


}; export default PreferenceGroupsGrid;
